import { Api, Auth } from '~/services'


export function getStatement( slug ) {
	return ( dispatch, getStore ) => {

		var data = Auth.getToken() ? {secure_token: Auth.getToken()} : {};
		
		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_STATEMENT'
				})

				Api.get( '/wp/statement/' + slug, data, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_STATEMENT',
						statement: data
					})
				})
			}
		)
	}
}


export function getReplies( statement_slug ) {
	return ( dispatch, getStore ) => {
		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_REPLIES'
				})

				Api.get( '/wp/statement/' + statement_slug + '/replies', {}, ( data, error ) => {
					if ( ! data.length || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_REPLIES',
						replies: data
					})
				})

			}
		)
	}
}


export function submitStatement( statement, campID ) {
	return ( dispatch, getStore ) => {

		if( !statement || !campID || !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_MAIN_FEED'
				})

				Api.post( '/wp/statement/', {
					statement: statement,
					campID: campID,
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( ! data || error ) {
						return;
					}
					dispatch({
						type: 'RECEIVE_VISIBLE_NOTIFICATION',
						notification: data.notification
					})
					dispatch({
						type: 'RECEIVE_NEW_MAIN_FEED',
						newPosts: [data.statement]
					})
				})
			}
		)

	}
}


export function submitReply( statementID, data, user ) {
	
	var reply = data.reply;
	var parent = 'parent' in data ? data.parent : 0;

	return ( dispatch, getStore ) => {
	
		if( !reply ) return;
		if( !Auth.getToken() ) return;

		return dispatch(
			dispatch => {

				dispatch({
					type: 'REQUEST_NEW_REPLY',
					statementID: statementID,
					reply: reply,
					parent: parent,
					user: user
				})

				Api.post( '/wp/statement/' + statementID + '/reply', {
					reply: reply,
					parent: parent,
					secure_token: Auth.getToken()
				}, ( data, error ) => {
					if ( error ) return;
					dispatch({
						type: 'RECEIVE_NEW_REPLY',
						statement: data
					})
				})

			}
		)
		
	}
}


export function toggleStatementFlare( id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		dispatch({
			type: 'REQUEST_UPDATED_STATEMENT'
		})

		Api.post( '/wp/statement/' + id + '/flare', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( error ) return;
			dispatch({
				type: 'RECEIVE_UPDATED_STATEMENT',
				statement: data
			})
		})
	}
	
}


export function toggleReplyFlare( id ) {

	return ( dispatch, getStore ) => {

		if( !Auth.getToken() ) return;

		dispatch({
			type: 'REQUEST_UPDATED_REPLY'
		})

		Api.post( '/wp/reply/' + id + '/flare', {
			secure_token: Auth.getToken()
		}, ( data, error ) => {
			if ( ! data || error ) {
				return;
			}
			dispatch({
				type: 'RECEIVE_UPDATED_REPLY',
				statementID: data.statement_id,
				reply: data.reply
			})
		})
	}
	
}







// WEBPACK FOOTER //
// ./src/js/actions/statement.js